<script setup lang="ts">
import Icon from '../../../Icon/Icon.vue';

interface Props {
  title: string;
  src?: string;
  isExternal?: boolean;
  text?: string;
  linkLabel?: string;
  icon?: string;
  showLink?: boolean;
  isTel?: boolean;
  isMailto?: boolean;
  hasChildren?: boolean;
}

defineProps<Props>();
const emit = defineEmits(['buttonClick']);

const handleTracking = (e) => {
  console.log('fab_cta_clicked', e.currentTarget);
  // GA button / link clicked
  // window.wtTrack.(extra: {
  //   event: 'fab_cta_clicked',
  //   ...baseEventPayload({
  //     target: `${e.currentTarget}`,
  //   }),
  // });
};

const handleClick = (e) => {
  handleTracking(e);
  emit('buttonClick', e);
};
</script>
<template>
  <a
    v-if="src"
    :class="[$style.container]"
    :href="isMailto ? `mailto:${src}` : isTel ? `tel:${src}` : src"
    :target="isExternal ? '_blank' : '_self'"
    @click="handleTracking"
  >
    <Icon v-if="icon" :class="$style.icon" :name="icon" size="large" />
    <div :class="$style.content">
      <h3>{{ title }}</h3>
      <p v-if="showLink" :class="$style.link">{{ src }}</p>
      <div v-if="text" v-html="text" />
    </div>
    <Icon v-if="isExternal" :class="$style.external" name="north_east" size="medium" />
    <Icon v-if="hasChildren" name="chevron_right" size="large" />
  </a>
  <button v-else :class="[$style.container]" @click="(e) => handleClick(e)">
    <Icon v-if="icon" :class="$style.icon" :name="icon" size="large" />
    <div :class="$style.content">
      <h3>{{ title }}</h3>
      <p v-if="showLink" :class="$style.link">{{ src }}</p>
      <div v-if="text" v-html="text" />
    </div>
    <Icon v-if="isExternal" :class="$style.external" name="north_east" size="medium" />
    <Icon v-if="hasChildren" name="chevron_right" size="large" />
  </button>
</template>
<style lang="sass" module src="./ContactLink.scss" />
